function formatDate(date: string): string {
  const [year, month, day] = date.split("T")[0].split("-");
  return `${month}/${day}/${year}`;
}

function formatToHTMLInputTime(dateTime: string): string {
  const date = new Date(dateTime);

  // Extract hours and minutes and ensure they are two digits
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  // Return in "HH:MM" format required by the HTML input
  return `${hours}:${minutes}`;
}

function formatDateTimeForBackend(time: string) {
  const currentDate = new Date().toISOString().split("T")[0]; // Gets current date in YYYY-MM-DD format
  return `${currentDate} ${time}:00`; // Combines date with time and adds seconds
}

const getViewersTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (e) {
    return "UTC";
  }
};

function parseDbTimestamp(value: unknown): Date | null {
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  const str = value == null ? "" : String(value).trim();
  if (!str) return null;
  const match = str.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?)?/
  );
  if (!match) {
    const parsed = new Date(str);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  if (!match[4]) {
    return new Date(
      parseInt(match[1], 10),
      parseInt(match[2], 10) - 1,
      parseInt(match[3], 10)
    );
  }
  const hasExplicitOffset = /(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(str);
  if (hasExplicitOffset) {
    const parsed = new Date(str.replace(" ", "T"));
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  const instant = Date.UTC(
    parseInt(match[1], 10),
    parseInt(match[2], 10) - 1,
    parseInt(match[3], 10),
    parseInt(match[4], 10),
    match[5] ? parseInt(match[5], 10) : 0,
    match[6] ? parseInt(match[6], 10) : 0
  );
  return new Date(instant);
}

function formatDbTimestamp(
  value: unknown,
  options: Intl.DateTimeFormatOptions
): string {
  const str = value instanceof Date ? "" : value == null ? "" : String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const [y, m, d] = str.split("-").map(Number);
    const literal = new Date(y, m - 1, d);
    try {
      return new Intl.DateTimeFormat("en-US", { ...options }).format(literal);
    } catch (e) {
      return str;
    }
  }
  const instant = parseDbTimestamp(value);
  if (!instant) return String(value ?? "");
  try {
    return new Intl.DateTimeFormat("en-US", { ...options }).format(instant);
  } catch (e) {
    return String(value ?? "");
  }
}

function hasStoreBalance(storeOrBalance: any): boolean {
  if (storeOrBalance == null) return false;
  const rawBalance =
    typeof storeOrBalance === "object"
      ? (storeOrBalance.commission_outstanding ?? storeOrBalance.balance)
      : storeOrBalance;
  if (rawBalance == null || rawBalance === "") return false;
  const balance = typeof rawBalance === "number" ? rawBalance : parseFloat(rawBalance);
  return !isNaN(balance) && balance > 0;
}

export { formatDate, formatToHTMLInputTime, formatDateTimeForBackend, hasStoreBalance, parseDbTimestamp, formatDbTimestamp, getViewersTimeZone};
